import { render, staticRenderFns } from "./independent.vue?vue&type=template&id=3c4f92aa&scoped=true&"
import script from "./independent.vue?vue&type=script&lang=js&"
export * from "./independent.vue?vue&type=script&lang=js&"
import style0 from "./independent.vue?vue&type=style&index=0&id=3c4f92aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c4f92aa",
  null
  
)

export default component.exports